import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { recordSiteVisit } from '../firebase/firestoreService';

export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    // Track one visit per route transition (including deep links).
    const routeKey = `${pathname}${search}`;
    try {
      const sessionKey = 'aif_last_tracked_route';
      const now = Date.now();
      let shouldTrack = true;

      const raw = sessionStorage.getItem(sessionKey);
      if (raw) {
        const parsed = JSON.parse(raw) as { route?: string; at?: number };
        if (parsed?.route === routeKey && typeof parsed?.at === 'number' && now - parsed.at < 4000) {
          shouldTrack = false;
        }
      }

      if (shouldTrack) {
        sessionStorage.setItem(sessionKey, JSON.stringify({ route: routeKey, at: now }));
        recordSiteVisit(routeKey).catch((error) => {
          console.warn('Site visit tracking skipped:', error);
        });
      }
    } catch (error) {
      // Tracking must never break navigation/scroll behavior.
      console.warn('Site visit tracking failed:', error);
    }

    // If navigating to an anchor/hash, attempt to scroll to that element.
    if (hash) {
      const id = hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        // prefer instant jump for consistent UX on route change
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }

    // Default: scroll to top
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
  }, [pathname, search, hash]);

  return null;
}
